import { useNavigate } from "react-router-dom"
import { Footer } from "../Footer"
import { Header } from "../Header"
import { HeroSection } from "../HeroSection"

export const CdatWhatsappManager = () => {

    const navigate = useNavigate()

    return (
        <>
            <Header active="Products" />
            <HeroSection />

            {/* ---------------------------------- */}

            <div className="row bgdotimg " id="LFMS">
                <div className="col-12 col-md-10 mx-auto py-4">
                    <h3 className="fw-bold colorcharchol text-center">CDAT WhatsApp Manager</h3>

                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>
                <div className="col-12 col-md-10 mx-auto py-3 text-center">
                    <p>
                        <b>CDAT WhatsApp Manager</b> is a comprehensive WhatsApp Business management platform that empowers businesses to create, manage, and analyze their WhatsApp marketing campaigns. With powerful template creation tools, user management features, message automation, and detailed analytics, CDAT streamlines your WhatsApp communication strategy. Whether you're sending promotional messages, notifications, or customer support responses, our platform ensures efficient delivery and provides actionable insights to optimize your messaging performance.
                    </p>
                </div>
            </div>
            {/* <!--end of main description--> */}

            <div className="row py-5 px-3" id="key">
                <div className="col-12 col-md-10 mx-auto py-1">
                    <h3 className="fw-bold colorcharchol text-center">KEY FEATURES</h3>

                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>TEMPLATE CREATION & MANAGEMENT</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>MULTI-CATEGORY TEMPLATES</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>USER & CONTACT MANAGEMENT</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>BULK MESSAGE SENDING</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>REAL-TIME ANALYTICS & REPORTS</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>MESSAGE SCHEDULING</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>DELIVERY STATUS TRACKING</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>CAMPAIGN PERFORMANCE INSIGHTS</b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>AUTOMATED RESPONSES</b></p>
                    </div>
                </div>
            </div>
            {/* <!--end of row key features--> */}

            {/* Template Categories Section */}
            <div className="row py-5 px-3 bg-light" id="template-categories">
                <div className="col-12 col-md-10 mx-auto py-1">
                    <h3 className="fw-bold colorcharchol text-center">TEMPLATE CATEGORIES</h3>
                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className="col-10 col-md-3 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <i className="fa-solid fa-bullhorn text-primary" style={{ fontSize: '30px' }}></i>
                        <p><b>MARKETING TEMPLATES</b></p>
                        <small>Promotional campaigns, offers, product launches</small>
                    </div>
                </div>

                <div className="col-10 col-md-3 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <i className="fa-solid fa-bell text-warning" style={{ fontSize: '30px' }}></i>
                        <p><b>NOTIFICATION TEMPLATES</b></p>
                        <small>Order updates, appointment reminders, alerts</small>
                    </div>
                </div>

                <div className="col-10 col-md-3 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <i className="fa-solid fa-headset text-success" style={{ fontSize: '30px' }}></i>
                        <p><b>SUPPORT TEMPLATES</b></p>
                        <small>Customer service, FAQ responses, help guides</small>
                    </div>
                </div>

                <div className="col-10 col-md-3 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <i className="fa-solid fa-calendar text-info" style={{ fontSize: '30px' }}></i>
                        <p><b>EVENT TEMPLATES</b></p>
                        <small>Invitations, announcements, follow-ups</small>
                    </div>
                </div>
            </div>

            {/* Analytics Dashboard Preview */}
            <div className="row py-5 px-3" id="analytics">
                <div className="col-12 col-md-10 mx-auto py-1">
                    <h3 className="fw-bold colorcharchol text-center">ANALYTICS & INSIGHTS</h3>
                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className="col-12 col-md-8 mx-auto text-center">
                    <div className="row">
                        <div className="col-6 col-md-3 mb-3">
                            <div className="card text-center p-3 border-0 shadow-sm">
                                <div className="text-primary">
                                    <i className="fa-solid fa-paper-plane" style={{ fontSize: '24px' }}></i>
                                </div>
                                <h5 className="mt-2 mb-1">Messages Sent</h5>
                                <small className="text-muted">Track delivery rates</small>
                            </div>
                        </div>
                        <div className="col-6 col-md-3 mb-3">
                            <div className="card text-center p-3 border-0 shadow-sm">
                                <div className="text-success">
                                    <i className="fa-solid fa-eye" style={{ fontSize: '24px' }}></i>
                                </div>
                                <h5 className="mt-2 mb-1">Read Rates</h5>
                                <small className="text-muted">Message engagement</small>
                            </div>
                        </div>
                        <div className="col-6 col-md-3 mb-3">
                            <div className="card text-center p-3 border-0 shadow-sm">
                                <div className="text-warning">
                                    <i className="fa-solid fa-reply" style={{ fontSize: '24px' }}></i>
                                </div>
                                <h5 className="mt-2 mb-1">Response Rate</h5>
                                <small className="text-muted">Customer interaction</small>
                            </div>
                        </div>
                        <div className="col-6 col-md-3 mb-3">
                            <div className="card text-center p-3 border-0 shadow-sm">
                                <div className="text-info">
                                    <i className="fa-solid fa-chart-line" style={{ fontSize: '24px' }}></i>
                                </div>
                                <h5 className="mt-2 mb-1">Campaign ROI</h5>
                                <small className="text-muted">Performance metrics</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row py-5 px-3" id="business-info">
                <div className="col-12 col-md-10 mx-auto py-1">
                    <h3 className="fw-bold colorcharchol text-center">Business Information</h3>
                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className="col-10 col-md-8 mx-auto box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto pt-5">
                        <div className="row">
                            <div className="col-3">
                                <b>Business Name :</b>
                            </div>
                            <div className="col-9">
                                <p>Center for Development of Advanced Technology, Pune</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <b>Physical Address : </b>
                            </div>
                            <div className="col-9">
                                <p>103-104, A2, Omkar Nandan, Navale Bridge, Opp.Navale IT Park, Vadgaon Bk. Pune-411041, Maharashtra, India.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <b>Contact Info : </b>
                            </div>
                            <div className="col-9">
                                <p className="cursor-pointer text-primary"
                                    target="_blank"
                                    onClick={() => window.open('https://cdat.co.in/ContactPage?ScreenName=Contact')}>
                                    <b className="text-decoration">Click to Contact Us </b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            {/* <div className="row py-5 px-3 bg-primary text-white" id="cta">
                <div className="col-12 text-center">
                    <h3 className="fw-bold mb-3">Ready to Transform Your WhatsApp Marketing?</h3>
                    <p className="mb-4">Start managing your WhatsApp campaigns like a pro with CDAT WhatsApp Manager</p>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <button className="btn btn-light btn-lg px-4" type="button">
                            <i className="fa-solid fa-rocket me-2"></i>
                            Get Started Now
                        </button>
                        <button className="btn btn-outline-light btn-lg px-4" type="button">
                            <i className="fa-solid fa-play me-2"></i>
                            View Demo
                        </button>
                    </div>
                </div>
            </div> */}

            <div className="col-12 col-md-10 mx-auto py-1 mb-5">
                <h3 className="fw-bold colorcharchol text-center">Policy</h3>
                <div className="zoom-in-out-box2 m-auto">
                    <hr />
                </div>
            </div>

            <div className="row col-lg-8 mx-auto box-sn py-5 mb-5 bg-white px-2">
                <div className="col-12 col-lg-4">
                    <div className="row cursor-pointer" target="_blank"
                        onClick={() => window.open('https://cdat.work/CDAT_Whatsapp_Privacy_Policy.html')}>
                        <div className="col-2 text-primary">
                            <i className="fa-solid fa-shield-halved"></i>
                        </div>
                        <div className="col-10 link_hover">
                            <span className="text-decoration">Privacy Policy </span>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-4">
                    <div className="row cursor-pointer" target="_blank"
                        onClick={() => window.open('https://cdat.work/CDAT_Terms_Services_Policy.html')}>
                        <div className="col-2 text-primary">
                            <i className="fa-solid fa-shield-halved"></i>
                        </div>
                        <div className="col-10 link_hover">
                            <span className="text-decoration">Terms & Services </span>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-4">
                    <div className="row cursor-pointer" target="_blank"
                        onClick={() => window.open('https://cdat.work/data_deletion.html')}>
                        <div className="col-2 text-primary">
                            <i className="fa-solid fa-shield-halved"></i>
                        </div>
                        <div className="col-10 link_hover">
                            <span className="text-decoration">Data Deletion Policy</span>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}